import React from 'react';
import { SearchBar, Icon, Link } from 'components';
import { useDebounce, useBreakpoint } from 'hooks';
import {
  StyledFilterButtonContainer,
  StyledListingsSearchWrapper,
} from './StyledSearchComponents';
import MyBrokerageContext from '../MyBrokerageContext';
import { SearchComponentType } from '../types';

const ListingsSearch: SearchComponentType = React.forwardRef((props, ref) => {
  const {
    queryData,
    setQueryData,
    clearSearchOptions,
    isAdvancedSearchOpen,
    setAdvancedSearchOpen,
    loading,
  } = React.useContext(MyBrokerageContext);
  const { md } = useBreakpoint();

  const [localSearchTerm, setLocalSearchTerm] = React.useState(
    queryData.searchTerm,
  );
  const debouncedTerm = useDebounce(localSearchTerm, 500);
  const componentDidMount = React.useRef(false);

  const handleClear = () => {
    clearSearchOptions();
    setLocalSearchTerm('');
  };

  React.useEffect(() => {
    if (!componentDidMount.current) {
      componentDidMount.current = true;
      return;
    }
    if (debouncedTerm !== queryData.searchTerm) {
      setQueryData(prev => ({
        ...prev,
        searchTerm: debouncedTerm,
        searchOptions: {
          ...queryData.searchOptions,
          avail: 'All',
        },
        pageNumber: 0,
      }));
    }
  }, [debouncedTerm]);

  React.useEffect(() => {
    setLocalSearchTerm(queryData.searchTerm);
  }, [queryData.searchTerm]);

  return (
    <StyledListingsSearchWrapper $isMobile={!md}>
      <SearchBar
        value={localSearchTerm}
        onChange={setLocalSearchTerm}
        loading={loading}
        allowClear
        ref={ref}
        placeholder="Address / MLS"
        suffix={
          <StyledFilterButtonContainer>
            <Link
              data-cy="search-toggle-filters"
              onClick={() => setAdvancedSearchOpen(prev => !prev)}
            >
              Filters
            </Link>
            {isAdvancedSearchOpen ? (
              <button onClick={handleClear}>
                <Icon type="x" width={12} color="primary" flipped />
              </button>
            ) : (
              <button onClick={() => setAdvancedSearchOpen(prev => !prev)}>
                <Icon type="arrowUpThin" width={10} color="primary" flipped />
              </button>
            )}
          </StyledFilterButtonContainer>
        }
        shape="round"
      />
    </StyledListingsSearchWrapper>
  );
});

export default ListingsSearch;
